import { CountryPrefix } from 'Jsx/global';

import { Mask, DefaultMask, AlphanumericMask } from '../../InputField/utils';

export const getMask = (countryPrefix: CountryPrefix): Mask => {
  switch (countryPrefix) {
    case 'ar':
      return new AlphanumericMask('########');
    case 'pe':
      return new AlphanumericMask('########');
    case 'br':
      return new AlphanumericMask('###.###.###-##');
    case 'co':
      return new AlphanumericMask('##########');
    case 'mx':
      return new AlphanumericMask('%%%%######%%%%%%!!');
    default:
      return new DefaultMask(30);
  }
};
